<!--
 * @Description: 组织架构（客户区域）级联选择组件
 * @Author: mdb
 * @Date: 2022-08-10 14:30:57
 * @LastEditTime: 2023-06-21 10:26:52
 * @LastEditors: cxh
-->
<template>
  <CustomerLabelCascaderText v-if="view" v-bind="attrs" :lastLeval="true" :appId="appId" :view="view" />
  <CosCascader v-else v-bind="attrs" :options="vaildCustomerLabelEnum" :placeholder="t('common.pleaseSelect')" allowClear />
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import useHook from './useHook'
import CustomerLabelCascaderText from './CustomerLabelCascaderText.vue'
const { t } = useI18n()

const props = defineProps({
  appId: {
    type: String,
    validator: (value: string) => {
      return ['cos_fbu', 'cos_ofbu', 'cos_lbu'].includes(value)
    },
    default: 'cos_lbu'
  },
  type: {
    type: String,
    default: 'search'
  },
  view: Boolean,
  onlyCommon: {
    type: Boolean,
    required: false,
    default: true
  }
})
const { customerLabelEnum } = useHook(props.appId)

const vaildCustomerLabelEnum = ref()

const attrs = computed(() => ({
  type: props.type,
  changeOnSelect: true,
  multiple: props.type && props.appId === 'cos_lbu', // 只有 search 类型 且为 cos_lbu 才支持多选
  maxTagCount: props.appId === 'cos_lbu' ? 'responsive' : undefined,
  fieldNames: props.appId === 'cos_lbu' ? { label: 'name', value: 'id' } : { label: 'label', value: 'id' }
}))

watch(
  () => customerLabelEnum.value,
  () => {
    vaildCustomerLabelEnum.value = disabledOptions(customerLabelEnum.value)
  },
  { immediate: true }
)

function disabledOptions(data: any[]) {
  const result: any[] = []

  for (const node of data) {
    if (props.onlyCommon && node.labelType === 1) {
      node.disabled = true
    }

    if (node.status === 0) { // && (!props.onlyCommon || node.labelType === 0)
      result.push(node)
    }
    if (node.children) {
      node.children = disabledOptions(node.children)
    }
  }
  return result

  // for (const node of data) {
  //   node.disabled = node.status === 1

  //   if (node.children) {
  //     disabledOptions(node.children)
  //   }
  // }
}
</script>
<script lang="ts">
export default { name: 'CustomerLabelCascader' }
</script>

<style scoped></style>
